import React from "react";
import { useState } from "react";
import PropTypes from 'prop-types';
import { Box, Flex, Text } from "theme-ui";
import { typography } from "../../styles/theme";
import { InfoTile, Pagination } from "../molecules";

const PaginatedTiles = ({ itemList, itemsPerPage = 3, linkPrefix }) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [startingIndex, setStartingIndex] = useState(0);
	const listLength = itemList?.length;

	return (
		<Flex sx={styles.container}>
			<Flex sx={styles.listWrapper}>
				{itemList
					.slice(startingIndex, currentPage * itemsPerPage)
					.map((item, i) => {
            const link = item?.slug ? `${linkPrefix}${item.slug}/`: item?.url;
						return (
							<Box
								key={`news-item-${i}`}
								sx={{ height: "100%", maxWidth: ["100%", "100%", "22rem", "24.313rem"] }}
							>
								<InfoTile
									title={item?.title}
									topLabel={
										<Text sx={{ ...typography.textSm }}>{item?.date}</Text>
									}
									image={item?.cardImage}
									imageAltText={item?.cardImage?.alt ?? item?.title}
									url={link}
									hasBorder={false}
									customStyles={{
										height: "100%"
									}}
								/>
							</Box>
						);
					})}
			</Flex>
			<Pagination
				currentPage={currentPage}
				totalItems={listLength}
				itemsPerPage={itemsPerPage}
				onPageChange={(activePage) => {
					setCurrentPage(activePage);
					setStartingIndex(activePage * itemsPerPage - itemsPerPage);
				}}
				customStyles={{ maxWidth: ["18.75rem", "20rem", "43rem"] }}
			/>
		</Flex>
	);
};

const styles = {
	container: {
		flexDirection: "column",
		width: "100%",
		gap: "3rem",
	},
	listWrapper: {
		width: "100%",
		flexWrap: "wrap",
		justifyContent: "center",
	},
};

PaginatedTiles.propTypes = {
  itemList: PropTypes.array,
  itemsPerPage: PropTypes.number,
  linkPrefix: PropTypes.string
}

export default PaginatedTiles;
